import { GraphNodeType } from "@custom-types/graphs"
import { NodeType } from "@features/builder/graph/types"
import { Chip } from "@mui/material"
import { getNodeTypeColor } from "@utils/node"

type NodeTypeChipProps = {
  type: GraphNodeType | NodeType
}

const NodeTypeChip = (props: NodeTypeChipProps) => {
  return (
    <Chip
      label={props.type}
      size="small"
      variant="outlined"
      sx={{
        color: "white",
        background: getNodeTypeColor(props.type),
        width: "16ch",
        textTransform: "capitalize",
      }}
    />
  )
}

export default NodeTypeChip
